import { Base } from '../Base';

export class SequencialTargeting extends Base {
  dropDownValue = [];

  isValid() {
    return (
      (Array.isArray(this.dropDownValue) && this.dropDownValue.length > 0)
    );
  }
}
